import { LitElement, css, html } from 'lit';
import { Image } from '../Image/Image';
import { Text } from '../Text/Text';
import '../Inputbox/Input';
import '../NewChatSidebar/NewChatSidebar';
import { clearAll, generateProfileImageByInitials } from '../../../lib/helpers';
import { drawerDialogService } from '../Dialog-Drawer/dialog-drawer';
import { Message_Add } from '../../../constants/chat-assets';
class SearchBar extends LitElement {
  static properties = {
    label: { type: String },
    labelColor: { type: String },
    labelFontFamily: { type: String },
    labelFontWeight: { type: String },
    labelFontSize: { type: String },
    labelFontStyle: { type: String },
    labelLineHeight: { type: String },
    searchBarIcon: { type: String },
    searchBarIconAlt: { type: String },
    searchBarIconWidth: { type: String },
    searchBarIconHeight: { type: String },
    height: { type: String },
    width: { type: String },
    borderRadius: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    borderStyle: { type: String },
    padding: { type: String },
    margin: { type: String },
    inputBgColor: { type: String },
    inputPlaceholderColor: { type: String },
    inputPlaceholder: { type: String },
    isSearchBar: { type: Boolean },
    inputFontColor: { type: String },
    showPopup: { type: Boolean },
    nonBlockedContacts: { type: Array },
    isNoContactsFound: { type: Boolean },
    isLoading: { type: Boolean },
    showLogoutPopup: { type: Boolean },
    inputValue: { type: String },
    conversationData: { type: Array },
    userMetaData: { type: Object },
    activeTab: { type: String },
    filteredConversations: { type: Array },
    leofferAccountId: { type: String },
    isPreloadingForFilter: { type: Boolean },
    isMqttConnected: { type: Boolean },
    handleNewChatClick: { type: Function },
    userMetaData: { type: Object },
    isSearchBarIcons: {type: Boolean},
    handleBackButtonClick: {type: Function}
  };

  static styles = css`
    .label-container {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .search-bar-container {
      display: flex;
      align-items: start;
      width: 100%;
      height: 100%;
      flex-direction: column;
      gap: 10px;
    }

    .search-bar-input {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      margin-bottom: 5px;
    }

    .search-bar-icons {
      position: relative;
      display: flex;
      align-items: center;
    }

    my-input {
      flex-grow: 1;
      font-family: 'Inter', sans-serif;
    }

    my-input:focus {
      outline: none;
      border-radius: 10px;
    }

    .icon-wrapper {
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      color: var(--label-color);
    }

    .tabs-container {
      display: flex;
      gap: 0;
      border-bottom: 2px solid var(--border-color);
      background-color: transparent;
      width: 100%;
    }

    .tab {
      flex: 1;
      padding: 12px 16px;
      text-align: center;
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.2s ease;
      border: none;
      background: transparent;
      color: var(--text-primary-color);
      position: relative;
    }

    .tab.active {
      color: var(--text-primary-color);
      font-weight: 600;
    }

    .tab.active::after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      right: 0;
      height: 2px;
      background-color: var(--base-color);
    }

    .tab:hover:not(.active) {
      color: var(--text-primary-color);
      background-color: transparent;
    }

    .tab:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .popup-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 25%;
      min-width: var(--sidebar-width);
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      display: flex;
      z-index: 1000;
      transition: transform 0.3s ease;
      transform: translateX(-100%);
    }

    new-chat-sidebar {
      width: 100%;
      height: 100%;
    }

    .popup-overlay.show {
      transform: translateX(0);
    }

    .popup-overlay.hide {
      transform: translateX(-100%);
    }

    .logout-popup {
      position: absolute;
      top: 40px;
      right: 0;
      background-color: var(--bg-primary-color);
      border-radius: 8px;
      box-shadow: var(--menu-shadow);
      padding: 8px;
      z-index: 1001;
      min-width: 120px;
    }

    .popup-menu-item {
      display: block;
      width: 100%;
      padding: 8px 12px;
      text-align: left;
      cursor: pointer;
      background-color: transparent;
      border: none;
      color: var(--text-primary-color, #333);
      font-size: 14px;
      transition: background-color 0.2s;
      border-radius: 4px;
    }

    .popup-menu-item:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
    .profile-menu {
      display: none;
    }
    .menuDot {
      displa: block;
    }
    .profile-dot {
      display: none;
    }
    .back-button {
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 4px;
    }
    @media (width < 768px) {
      .back-button {
        display: flex;
        align-items: center;
      }
      .popup-overlay {
        width: 100%;
      }
      .search-bar-icons {
        gap: 10px;
      }
      .menuDot {
        display: none;
      }
      .profile-dot {
        display: block;
        position: relative;
      }
      .mqtt-indicator {
        position: absolute;
        right: 0px;
        bottom: 7px;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        filter: blur(0.3px);
      }

      .mqtt-indicator.connected {
        background-color: var(--text-success-color);
      }

      .mqtt-indicator.disconnected {
        background-color: var(--text-danger-color);
      }
      .profile-menu {
        display: block;
      }
    }
  `;

  constructor() {
    super();
    this.showPopup = false;
    this.isLoading = false;
    this.showLogoutPopup = false;
    this.inputValue = '';
    this.activeTab = 'all';
    this.filteredConversations = [];
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.isSearchBarIcons = true;
    
  
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('close-sidebar', this.closePopup);
    document.addEventListener('click', this.handleClickOutside);
    
    
    
    // Initialize filtering for default "all" tab
    setTimeout(() => {
      this.filterConversations();
    }, 100);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('close-sidebar', this.closePopup);
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside(e) {
    const logoutPopup = this.shadowRoot.querySelector('.logout-popup');
    const settingsIcon = this.shadowRoot.querySelector('.settings-icon');

    if (logoutPopup && !logoutPopup.contains(e.target) && !settingsIcon.contains(e.target)) {
      this.showLogoutPopup = false;
    }
  }

  handleInputChange(e) {
    // Prevent event bubbling
    e.stopPropagation();

    const inputValue = e.target.value;
    this.inputValue = inputValue;
    this.dispatchEvent(
      new CustomEvent('searchConversation', {
        detail: { value: inputValue },
        bubbles: true,
        composed: true,
      }),
    );
  }

  handleSvgClick(e) {
    e.stopPropagation();
    this.showLogoutPopup = !this.showLogoutPopup;
  }

  handleLogout(e) {
    e.stopPropagation();
    this.showLogoutPopup = !this.showLogoutPopup;
    drawerDialogService.openDialog('confirm-dialog', {
      title: 'Logout',
      description: `Are you sure you want to Logout ?`,
      handleConfirm: clearAll,
    });
  }

  handleProfileClick() {
    this.dispatchEvent(
      new CustomEvent('profile-clicked', {
        bubbles: true,
        composed: true,
      }),
    );
    this.showLogoutPopup = false;
  }

  closePopup() {
    const overlay = this.shadowRoot.querySelector('.popup-overlay');
    overlay.classList.add('hide');
    setTimeout(() => {
      this.showPopup = false;
      this.requestUpdate();
    }, 300);
  }

  clearInput() {
    this.inputValue = '';
    const input = this.shadowRoot.querySelector('my-input');
    if (input) {
      input.value = '';
      this.dispatchEvent(
        new CustomEvent('searchConversation', {
          detail: { value: '' },
          bubbles: true,
          composed: true,
        }),
      );
    }
  }

  handleTabClick(tab) {
    this.activeTab = tab;
    this.filterConversations(tab);
 
  
  }

  filterConversations(tab = this.activeTab) {
   
    
    if (!this.conversationData || this.conversationData.length === 0) {
      this.filteredConversations = [];
      // Still dispatch the event even with empty data
      this.dispatchEvent(
        new CustomEvent('filteredConversationsChanged', {
          detail: { 
            filteredConversations: this.filteredConversations,
            activeTab: this.activeTab 
          },
          bubbles: true,
          composed: true,
        }),
      );
      return;
    }

    switch (tab) {
      case 'all':
        // Show all conversations regardless of userMetaData
        this.filteredConversations = this.conversationData;
        break;
      case 'buying':
        if (!this.userMetaData || !this.leofferAccountId) {
          this.filteredConversations = [];
          break;
        }
        this.filteredConversations = this.conversationData.filter(conversation => {
          const isBuying = this.leofferAccountId === conversation?.metaData?.buyerAccountId;
       
          return isBuying;
        });
        break;
      case 'selling':
        if (!this.userMetaData || !this.leofferAccountId) {
          this.filteredConversations = [];
          break;
        }
        this.filteredConversations = this.conversationData.filter(conversation => {
          const isSelling = this.leofferAccountId === conversation?.metaData?.sellerAccountId;
         
          return isSelling;
        });
        break;
      default:
        this.filteredConversations = this.conversationData;
        break;
    }
    
    
    // Dispatch event with filtered conversations
    this.dispatchEvent(
      new CustomEvent('filteredConversationsChanged', {
        detail: { 
          filteredConversations: this.filteredConversations,
          activeTab: this.activeTab 
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  updated(changedProperties) {
    super.updated(changedProperties);
    
  
    
    if (changedProperties.has('conversationData') || changedProperties.has('userMetaData')) {
      this.filterConversations();
    }
  }

  render() {
    this.style.setProperty('--label-color', this.labelColor);
    return html`
      <div
        class="search-bar-container"
        style="width: ${this.width}; height: ${this.height}; 
      padding: ${this.padding};
      margin: ${this.margin};
    "
      >
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
              <div class="back-button" @click=${this.handleBackButtonClick}>
                                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="${this.labelColor}"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg>
              </div>
          ${Text({
            content: this.label || 'Inbox',
            color: this.labelColor || '#333',
            fontFamily: this.labelFontFamily || 'Inter, sans-serif',
            fontWeight: this.labelFontWeight || '600',
            fontSize: this.labelFontSize || '24px',
            fontStyle: this.labelFontStyle || 'normal',
            lineHeight: this.labelLineHeight || '1.2',
          })}
          <div @click="${this.handleNewChatClick}" class="search-bar-icons">
          
            ${this.showLogoutPopup
              ? html`
                  <div class="logout-popup">
                    <button class="popup-menu-item profile-menu" @click="${this.handleProfileClick}">My Profile</button>
                    <button class="popup-menu-item" @click="${e => this.handleLogout(e)}">Log Out</button>
                  </div>
                `
              : ''}

             

          </div>
        </div>
        ${this.isSearchBar
          ? html`
              <div class="search-bar-input">
                <div style="position: relative; width: 100%;">
                  <div style="position: absolute; left: 12px; top: 50%; transform: translateY(-50%); z-index: 1;">
                    <svg style="width: 18px; height: 18px; color: var(--text-secondary-color);" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.5 15.5L19 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M5 11C5 14.3137 7.68629 17 11 17C12.6597 17 14.1621 16.3261 15.2483 15.2483C16.3261 14.1621 17 12.6597 17 11C17 7.68629 14.3137 5 11 5C7.68629 5 5 7.68629 5 11Z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <my-input
                    width="100%"
                    minHeight="45px"
                    maxHeight="45px"
                    inputHeight="45px"
                    borderRadius="12px"
                    borderWidth="0px"
                    borderStyle="solid"
                    backgroundColor="var(--bg-secondary-color)"
                    fontSize="14px"
                    padding="12px 12px 12px 40px"
                    placeholder="${this.inputPlaceholder || 'Search messages, usernames'}"
                    color="var(--text-primary-color)"
                    .placeholderColor="var(--text-secondary-color)"
                    @input="${this.handleInputChange}"
                    .value="${this.inputValue}"
                  ></my-input>
                  
                  ${this.inputValue
                    ? html`
                        <div style="position: absolute; right: 12px; top: 50%; transform: translateY(-50%); cursor: pointer;" @click="${this.clearInput}">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" fill="none">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                              fill="var(--text-secondary-color)"
                            />
                          </svg>
                        </div>
                      `
                    : ''}
                </div>
              </div>
            `
          : ''}
        
        ${this.isSearchBar
          ? html`
              <div class="tabs-container">
                <button 
                  class="tab ${this.activeTab === 'all' ? 'active' : ''}"
                  @click="${() => this.handleTabClick('all')}"
                >
                  All
                </button>
                <button 
                  class="tab ${this.activeTab === 'buying' ? 'active' : ''}"
                  @click="${() => this.handleTabClick('buying')}"
                  ?disabled="${this.isPreloadingForFilter}"
                >
                  Buying
                  ${this.isPreloadingForFilter && this.activeTab === 'buying' ? html`<span style="margin-left: 5px;">⏳</span>` : ''}
                </button>
                <button 
                  class="tab ${this.activeTab === 'selling' ? 'active' : ''}"
                  @click="${() => this.handleTabClick('selling')}"
                  ?disabled="${this.isPreloadingForFilter}"
                >
                  Selling
                  ${this.isPreloadingForFilter && this.activeTab === 'selling' ? html`<span style="margin-left: 5px;">⏳</span>` : ''}
                </button>
              </div>
            `
          : ''}
      </div>

      ${this.showPopup
        ? html`
            <div class="popup-overlay show">
              <new-chat-sidebar
                .closeNewChatSidebar=${() => this.closePopup()}
                height="100%"
                width=""
                bgColor="var(--bg-primary-color)"
                textColor="var(--text-primary-color)"
                .nonBlockedContacts=${this.nonBlockedContacts}
                .isNoContactsFound=${this.isNoContactsFound}
                .isLoading=${this.isLoading}
              ></new-chat-sidebar>
            </div>
          `
        : ''}
    `;
  }
}

customElements.define('message-search-bar', SearchBar);
